import React from 'react';
import { useTranslation } from 'react-i18next';
import Switch from '../../../../../components/ui/Switch';

interface BrandingToggleProps {
  enabled: boolean;
  onToggle: () => void;
}

const BrandingToggle: React.FC<BrandingToggleProps> = ({ enabled, onToggle }) => {
  const { t } = useTranslation();

  return (
    <div className="mb-6">
      <div className="flex items-center justify-between p-4 bg-muted rounded-lg">
        <div>
          <h4 className="text-sm font-medium text-foreground">
            {t('Enable Custom Branding')}
          </h4>
          <p className="text-sm text-muted-foreground">
            {t('Apply custom branding to all generated payslips')}
          </p>
        </div>
        <Switch checked={enabled} onCheckedChange={onToggle} />
      </div>
    </div>
  );
};

export default BrandingToggle;
